export default {
    bloglist: {
        en: [
            {
                title: 'How to Fix GB WhatsApp Banned Problem',
                poster: require('@/assets/blog-1.webp'),
                desc: "Learn why GB WhatsApp gets banned, how to fix temporary and permanent bans (including reinstalling the latest version, contacting support, using a new number), and tips to prevent future bans. Solutions for common unban issues are also covered.",
                name: 'blog-1',
                url: 'https://gbappapk.org/how-to-fix-gbwhatsapp-banned-problem/',
                date:"2025-09-01",
            },
            {
                title: 'Is GBWhatsApp Safe? What You Need to Know Before Installing',
                poster: require('@/assets/blog-2.webp'),
                desc: "Curious about GBWhatsApp's safety? Learn how to install the official version safely, steer clear of fake apps, and make the most of its unique features without risks",
                name: 'blog-2',
                url: 'https://gbappapk.org/is-gbwhatsapp-safe/',
                date:"2025-09-09",
            },
            {
                title: 'How to Send Larger Files on GBWhatsApp？',
                poster: require('@/assets/blog-3-1.webp'),
                desc: "Step-by-step guide on how to send larger files on GBWhatsApp, including high-resolution videos, images, and documents. Learn tips for hassle-free file sharing.",
                name: 'blog-3',
                url: 'https://gbappapk.org/send-larger-files-on-gbwhatsapp/',
                date:"2025-09-30",
            },
            {
                title: 'Transform Your Chats: The Hidden Aesthetic Power of GBWhatsApp',
                poster: require('@/assets/blog-4.webp'),
                desc: "GBWhatsApp isn't just about privacy — it's about expression. Discover how custom themes, icons, and fonts can completely change your chatting experience.",
                name: 'blog-4',
                url: 'https://gbappapk.org/transform-your-chats-hidden-aesthetic-power-gbwhatsapp/',
                date:"2025-10-20",
            },
            {
                title: 'Stay Organized with GBWhatsApp\'s Group Chats Segregation Feature',
                poster: require('@/assets/blog-5-1.webp'),
                desc: 'Keep personal and group chats organized with GBWhatsApp\'s Group Chats Segregation feature and boost focus for a smoother messaging experience.',
                name: 'blog-5',
                url: 'https://gbappapk.org/group-chats-segregation/',
                date:"2025-10-27",
            },
            // {
            //     title: 'How to Change Fonts on GBWhatsApp Easily',
            //     poster: require('@/assets/blog-1.webp'),
            //     desc: "GBWhatsApp is one of the most popular WhatsApp mods in 2025, loved for its extra features and customization options. Among its most sought-after features is the ability to change fonts in GBWhatsApp — giving your chats a fresh, stylish look.",
            //     name: 'en-blog1',
            //     url: 'https://gbappapk.org/how-change-fonts-on-gbwhatsapp/',
            //     date:"2025-08-15",
            // }
            {
                title: 'How to Fix Location Not Working in GBWhatsApp',
                poster: require('@/assets/blog-6.webp'),
                desc: "Fix GBWhatsApp location not working issues by checking phone location services, permissions, GPS signal, Google Play Services, and updating the GBWhatsApp app version.",
                name: 'en-how-to-fix-location-not-working-in-gbwhatsapp',
                url: '/how-to-fix-location-not-working-in-gbwhatsapp/',
                date: "2026-03-11",
            },
            {
                title: 'GB WhatsApp Calls Not Working: Fix Guide',
                poster: require('@/assets/blog-7.webp'),
                desc: "Having trouble making or receiving calls on GB WhatsApp? Learn how to fix voice and video call issues caused by connection, permissions, battery settings, VPN, cache, or app version problems.",
                name: 'blog-7',
                url: '/gb-whatsapp-calls-not-working/',
                date: "2026-08-24",
            },
            {
                title: 'GB WhatsApp Keeps Crashing? 7 Easy Ways to Fix It',
                poster: require('@/assets/blog-8.webp'),
                desc: "GB WhatsApp keeps crashing or closing by itself? Find out why it happens and try simple fixes for cache, storage, permissions, updates, and more.",
                name: 'blog-8',
                url: '/gb-whatsapp-keeps-crashing/',
                date: "2026-08-24",
            },
        ],
    }
    
}
